import javaService from "../../utils/request"

 // 教学视频
 export function video_list(data){
  return javaService({
    url: '/front/instructionalVideo',
    method: 'GET',
    params: data
  })
 }
